import type { RequiredGeneric } from '@pba/react-utils';
import { Fieldset, Flex, Form, Radio, Text } from 'ui';

export type BadgeNotificationFormContentValues = {
  badgeNotificationsSettings: { enableNotifications: boolean };
};

const BadgeNotificationFormContent = <T extends BadgeNotificationFormContentValues = never>(_: RequiredGeneric<T>) => (
  <Fieldset legend={{ title: 'Badge Notifications', visible: false }}>
    <Flex gap={8} vertical>
      <Text size="small" type="title" uppercase weight="medium">
        Badge Notifications
      </Text>

      <Form.Item<BadgeNotificationFormContentValues>
        name={['badgeNotificationsSettings', 'enableNotifications']}
        rules={[{ required: true }]}
      >
        <Radio.Group>
          <Radio value>On</Radio>
          <Radio value={false}>Off</Radio>
        </Radio.Group>
      </Form.Item>
    </Flex>
  </Fieldset>
);

export default BadgeNotificationFormContent;
